import { media } from '@/styles/Qtheme';
import styled from 'styled-components';

export const Wrapper = styled.div`
  background: rgba(0, 110, 73, 0.08);
  border-radius: 24px;
  padding: 0 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 120px;
  height: 92px;
  width: fit-content;
  box-sizing: border-box;
  position: relative;
  border: 1px solid transparent;
  transition: border-color 0.2s ease;
  cursor: pointer;

  &:hover {
    border-color: #07d993;
  }

  @media ${media.mobile} {
    width: 100%;
    padding: 0 16px;
    gap: 12px;
    height: 80px;
  }
`;

export const CoinInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CoinIcon = styled.img`
  width: 46px;
  height: 46px;

  position: relative;
  bottom: 1px;

  @media ${media.mobile} {
    width: 32px;
    height: 32px;
  }
`;

export const CoinName = styled.p`
  font-family: 'SB Aggro', 'Aggro', sans-serif;
  font-weight: 500;
  font-size: 24px;
  letter-spacing: -0.02em;
  color: #ffffff;
  white-space: nowrap;
  margin: 0;

  @media ${media.mobile} {
    font-size: 20px;
  }
`;

export const ArrowButton = styled.div<{ $isOpen?: boolean }>`
  background: rgba(0, 110, 73, 0.08);
  border-radius: 10px;
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  transition: transform 0.2s ease;
  flex-shrink: 0;

  svg {
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0)')};
    transition: transform 0.2s ease;
  }

  &:hover {
    background: rgba(0, 110, 73, 0.15);
  }

  @media ${media.mobile} {
    width: 32px;
    height: 32px;
  }
`;

export const ArrowIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  right: 0;
  background: #0d1117;
  border-radius: 24px;
  max-height: 450px;
  overflow: hidden;
  z-index: 100;
  display: flex;
  flex-direction: column;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 46px;
  padding: 4px 12px;
  margin: 32px 44px 24px;
  background: #0d1117;
  border: 1px solid #353535;
  border-radius: 12px;
  box-sizing: border-box;
  flex-shrink: 0;
`;

export const SearchIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 14px;
  letter-spacing: -0.02em;
  color: #ffffff;

  &::placeholder {
    color: #b3b5bd;
  }
`;

export const DropdownList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  flex: 1;
  padding: 0 44px 32px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }
`;

export const DropdownItem = styled.div<{ $isSelected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: opacity 0.15s ease;

  &:hover {
    opacity: 0.8;
  }
`;

export const DropdownItemIcon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;

  @media ${media.mobile} {
    width: 20px;
    height: 20px;
  }
`;

export const DropdownItemText = styled.span<{ $isSelected?: boolean }>`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: -0.02em;
  color: ${({ $isSelected }) => ($isSelected ? '#ff8a00' : '#b3b5bd')};
  transition: color 0.15s ease;

  &:hover {
    color: ${({ $isSelected }) => ($isSelected ? '#ff8a00' : '#ffffff')};
  }

  @media ${media.mobile} {
    font-size: 14px;
  }
`;
